import { useNode, useEditor, Element } from "@craftjs/core";
import React, { useContext, useEffect } from "react";
import GrigoraCSSRenderer from "./../css-render";
import { DropdownSettings } from "./settings";
import icon from "./icon";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";
import { Container } from "../container";
import { Text } from "../text";
import { Icon } from "../icon";
import { GrigoraDashboardContext } from "../../dashboard/context";

export const Dropdown = (props) => {
  const {
    id,
    connectors: { connect, drag },
    selected,
    actions: { setProp },
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const {
    query: { node },
    actions: { selectNode },
  } = useEditor();

  const { blockState, setBlockState } =
    useContext(GrigoraDashboardContext) ?? {};

  const { openListOnHover } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-dropdown": true,
      [`dropdown-${id}`]: id,
      "is-opened": blockState?.(id)?.["is-opened"],
    },
    blockProps.className,
  );

  useEffect(() => {
    if (openListOnHover) {
      setBlockState(id, "is-opened", false);
    }
  }, []);

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      className={wrapperClass}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__Dropdown(id, props)}`}</style>
      <Element
        id={`dropdown-toggle-${id}`}
        canvas
        direction="row"
        width="100%"
        alignItems="center"
        justifyContent="space-between"
        display={"flex"}
        is={Container}
        custom={{
          displayName: "Dropdown Toggle",
        }}
      >
        <Element is={Text} content="Dropdown"></Element>
        <Element is={Icon} icon="chevron-down" content="Dropdown"></Element>
      </Element>
      <div className={`dropdown-list`}>
        <Element
          custom={{
            displayName: "Dropdown List",
          }}
          canvas
          id={`dropdown-list-${id}`}
          is={Container}
        ></Element>
      </div>
    </div>
  );
};

// To Avoid Mangling in Production
Dropdown.displayName = "Dropdown";

Dropdown.craft = {
  name: "Dropdown",
  props: {},
  related: {
    icon: icon,
    category: "basic",
    supports: [
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    settings: DropdownSettings,
    keywords: ["Dropdown", "Dropdown Input", "Dropdown"],
    isHiddenInPostEditor: true,
  },
  custom: {
    name: "Dropdown",
    slug: "grigora/dropdown",
  },
};
